import { create as createAxios, type AxiosInstance } from 'axios';

import { axiosConfig, camelizeResponse } from './axiosConfig';

// Auth endpoints are called without apiClient's bearer-token interceptor:
// login should not try to refresh an old session before accepting credentials,
// and refresh must not recurse through the 401 replay path.
export const authClient: AxiosInstance = createAxios(axiosConfig);

authClient.interceptors.response.use(camelizeResponse);
